// extracted by mini-css-extract-plugin
export default {"ingredient":"ShowDrink_ingredient__pErQr"};